import React from "react";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";

const CarritoProductos = () => {
    const { carritoPedidos = [] } = useContextUsuario();

    return (
        <div className="container py-3">
            <h4 className="text-primary fw-bold mb-4 text-center text-md-start">
                Productos seleccionados
            </h4>

            {carritoPedidos.length === 0 ? (
                <div className="text-center py-5">
                    <p className="text-muted fst-italic mb-3">
                        No tienes productos en tu carrito.
                    </p>
                    <i className="fas fa-shopping-cart fa-3x text-light"></i>
                </div>
            ) : (
                <div className="row g-3">
                    {carritoPedidos.map((producto) => (
                        <div key={producto.id} className="col-12">
                            <div className="card shadow-sm h-100">
                                <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                    <div className="me-md-3 mb-2 mb-md-0 text-center">
                                        <img
                                            src={producto.imagen || "/productos.jpg"}
                                            alt={producto.nombre}
                                            className="img-thumbnail"
                                            style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                        />
                                    </div>
                                    <div className="flex-grow-1 text-center text-md-start">
                                        <h5 className="card-title mb-1 text-primary mx-4">{producto.nombre}</h5>
                                        <p className="card-text text-muted mb-1">Cantidad: <span className="fw-bold">{producto.cantidad}</span></p>
                                        <p className="card-text text-muted mb-0">Precio Unitario: <span className="fw-bold">L {parseFloat(producto.precio).toFixed(2)}</span></p>
                                    </div>
                                    <div className="text-md-end mt-2 mt-md-0">
                                        <span className="badge bg-primary rounded-pill fs-5 p-2">
                                            L {parseFloat(producto.price).toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="col-12 mt-4">
                        <div className="card shadow-sm">
                            <div className="card-body text-end">
                                <h5 className="fw-bold text-primary">
                                    Total del Carrito: L{" "}
                                    {carritoPedidos
                                        .reduce((acc, item) => acc + parseFloat(item.price || 0), 0)
                                        .toFixed(2)}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CarritoProductos;